module.exports = __webpack_public_path__ + "static/media/WiredMobile.e6f0777d.png";